import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Sidebar from "./Siderbar";
import Topbar from "./Topbar";
import Footer from "./Footer";

const DashboardDesign = () => {
  const baseURL = process.env.REACT_APP_API_BASE_URL;
  const navigate = useNavigate();

  // Initialize form data state
  const [formData, setFormData] = useState({
    product: "",
    dname: "",
    image: null,
    min_qty: "",
    price: "",
    size: "",
    type: "",
    side: "",
    corner: "",
    lamination: "",
    cover: "",
    page_layout: "",
    sticker_size: "",
    inner_paper: "",
    pages: "",
  });

  const [products, setProducts] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedProduct, setSelectedProduct] = useState("");

  // Handle category change to fetch corresponding products
  const handleCategoryChange = async (e) => {
    const categoryId = e.target.value;
    setSelectedCategory(categoryId);

    if (categoryId) {
      try {
        const response = await axios.get(`${baseURL}/api/products-inndus?category=${categoryId}`);
        setProducts(response.data);
      } catch (error) {
        console.error("Error fetching products:", error);
      }
    } else {
      setProducts([]);
    }
  };

  // Handle product selection
  const handleProductChange = (e) => {
    setSelectedProduct(e.target.value);
    setFormData((prev) => ({
      ...prev,
      product: e.target.value,
    }));
  };

  // Handle form field changes
  const handleChange = (e) => {
    const { name, type, value, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  // Handle file input change (for image upload)
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setFormData((prev) => ({
      ...prev,
      image: file,
    }));
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Prepare form data for submission
    const formDataObj = new FormData();
    formDataObj.append("product", formData.product);
    formDataObj.append("dname", formData.dname);
    formDataObj.append("min_qty", formData.min_qty);
    formDataObj.append("price", formData.price);
    formDataObj.append("image", formData.image);

    // Append other fields dynamically
    Object.keys(formData).forEach((key) => {
      if (
        !["product", "dname", "min_qty", "price", "image"].includes(key) &&
        formData[key] !== ""
      ) {
        formDataObj.append(key, formData[key]);
      }
    });

    try {
      const response = await axios.post(`${baseURL}/api/add-inndus-design`, formDataObj, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      alert("Product added successfully!");
      console.log(response.data);
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

  return (
    <>
      <div className="d-flex">
        <Sidebar />
        <div className="flex-grow-1 d-flex flex-column" style={{ minHeight: "100vh" }}>
          <Topbar />
          <div className="flex-grow-1 p-4">
            <form onSubmit={handleSubmit} className="container mt-4">
              <h2 className="mb-4">Add Design</h2>

              {/* Category Selection */}
              <div className="mb-3">
                <label className="form-label">Category</label>
                <select
                  value={selectedCategory}
                  onChange={handleCategoryChange}
                  className="form-control"
                  required
                >
                  <option value="" disabled>
                    -- Select Category --
                  </option>
                  <option value="1">Stationery</option>
                  <option value="2">Gifts</option>
                  <option value="3">Marketing Collaterals</option>
                  <option value="4">Packaging</option>
                  <option value="5">Personalise Products</option>
                </select>
              </div>

              {/* Product Selection based on selected category */}
              <div className="mb-3">
                <label className="form-label">Product</label>
                <select
                  value={selectedProduct}
                  onChange={handleProductChange}
                  className="form-control"
                  name="product"
                  disabled={!selectedCategory}
                >
                  <option value="">Select a product</option>
                  {products.map((product) => (
                    <option key={product.pid} value={product.pid}>
                      {product.pname}
                    </option>
                  ))}
                </select>
              </div>

              {/* Design Name */}
              <div className="mb-3">
                <label className="form-label">Design Name</label>
                <input
                  type="text"
                  name="dname"
                  value={formData.dname}
                  onChange={handleChange}
                  className="form-control"
                  required
                />
              </div>

              {/* File Input for Image */}
              <div className="mb-3">
                <label className="form-label">Image</label>
                <input
                  type="file"
                  name="image"
                  className="form-control"
                  onChange={handleFileChange}
                  required
                />
              </div>

              {/* Min Quantity */}
              <div className="mb-3">
                <label className="form-label">Min Quantity</label>
                <input
                  type="text"
                  name="min_qty"
                  value={formData.min_qty}
                  onChange={handleChange}
                  className="form-control"
                  required
                />
              </div>

              {/* Price */}
              <div className="mb-3">
                <label className="form-label">Price</label>
                <input
                  type="text"
                  name="price"
                  value={formData.price}
                  onChange={handleChange}
                  className="form-control"
                  required
                />
              </div>

              {/* Additional fields for other attributes */}
              {[
                "size",
                "type",
                "side",
                "corner",
                "lamination",
                "cover",
                "page_layout",
                "sticker_size",
                "inner_paper",
                "pages",
              ].map((field) => (
                <div key={field} className="mb-3">
                  <label className="form-label">
                    {field.replace("_", " ").toUpperCase()}
                  </label>
                  <textarea
                    name={field}
                    className="form-control"
                    value={formData[field]}
                    onChange={handleChange}
                    placeholder="Enter comma-separated values (e.g., value1, value2)"
                  />
                </div>
              ))}

              {/* Submit Button */}
              <button type="submit" className="btn btn-primary">
                Submit
              </button>
            </form>
          </div>
          <Footer />
        </div>
      </div>
    </>
  );
};

export default DashboardDesign;
